module.exports = __webpack_public_path__ + "img/Just Fresh.7b4a9bb2.jpeg";